import React, { useContext, useMemo, useState } from "react";
import { LangContext } from "../../context/lang/LangContext";
import { PhosphorIcon } from "../PhosphorIcon/PhosphorIcon";
import { Link } from "gatsby";
import { useGoogleAnalyticsEvent } from "../../hooks/useGoogleAnalitycs";
import {
  EventsAction,
  EventsCategories,
} from "../../utils/enums/googleAnalyticsEvents";

export enum PrivacyLocalStorageKeys {
  AcceptedCookies = "acceptedCookies",
}

export const PrivacyAdvice = () => {
  const { messages } = useContext(LangContext);

  const [onClickPrivacyAdviceAccept] = useGoogleAnalyticsEvent([
    {
      action: EventsAction.Click,
      category: EventsCategories.Index,
      label: "PrivacyAdvice",
      actionName: "PrivacyAdvice",
      value: 1,
    },
  ]);

  const isAcceptedCookies = useMemo(() => {
    if (typeof window === "undefined") return false;
    return (
      localStorage.getItem(PrivacyLocalStorageKeys.AcceptedCookies) === "true"
    );
  }, []);

  const [isPrivacyAdviceOpen, setIsPrivacyAdviceOpen] =
    useState(isAcceptedCookies);

  const cookiesPrivacyLink = useMemo(() => {
    return `/${messages.currentLanguage}/for-developers/${
      messages.currentLanguage === "es"
        ? "politica-de-cookies-y-privacidad"
        : "cookies-and-privacy-policy"
    }/`;
  }, []);

  const handleAcceptAllCookies = () => {
    onClickPrivacyAdviceAccept(null);
    setIsPrivacyAdviceOpen(true);
    if (typeof window === "undefined") return false;
    localStorage.setItem(PrivacyLocalStorageKeys.AcceptedCookies, "true");
  };

  return (
    <>
      {!isPrivacyAdviceOpen && (
        <div className="PrivacyAdvice__container">
          <div className="PrivacyAdvice__container_body">
            <button
              className="PrivacyAdvice__close_button"
              onClick={handleAcceptAllCookies}
            >
              <PhosphorIcon icon="x" size={16} />
            </button>
            <div className="PrivacyAdvice__body">
              <div className="PrivacyAdvice__copy">
                <span>{messages.privacyAdvice.weUseCookiesToEnhanceYour}</span>
                <Link to={cookiesPrivacyLink + "#cookies-policy"}>
                  {messages.privacyAdvice.cookiePolicy}
                </Link>
                <span>{messages.privacyAdvice.and}</span>
                <Link to={cookiesPrivacyLink}>
                  {messages.privacyAdvice.privacyAndDataPolicy}
                </Link>
                <span>{messages.privacyAdvice.forMoreInformation}</span>
              </div>
              <button
                className="PrivacyAdvice__accept_button"
                onClick={handleAcceptAllCookies}
              >
                {messages.privacyAdvice.acceptAllCookies}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
